import _extends from '../../../../node_modules/@babel/runtime/helpers/extends.js';
import { forwardRef, useMemo } from 'react';
import 'prop-types';
import { useReactlyticsHandlers } from '@americanexpress/reactlytics';
import merge from 'deepmerge';
import btnReset from '../../../utils/styles.js';
import btn from '../../../styles/btn.js';
import { jsx } from '@emotion/core';

const ButtonBase = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    theme,
    styled,
    size,
    isDark,
    allowOverflow,
    ...otherProps
  } = useReactlyticsHandlers(props, ['onClick']);
  const cssStyle = useMemo(() => merge.all([btnReset, styled ? btn.btn : {
    minWidth: '2.75rem',
    padding: '0.6875rem 0'
  }, allowOverflow ? btn.btnOverflow : {}, size === 'sm' ? {
    ...btn.btnSm,
    ...btn.btnBlock
  } : {}, !styled && size === 'sm' ? {
    ...btn.btnSm,
    ...btn.btnBlock,
    padding: '0.5625rem 0'
  } : {}, theme]), [allowOverflow, size, theme, styled]);
  const btnWrapper = {
    ...btn.btnSmWrapper,
    ':focus > span': isDark ? {
      ...btn.btnWhite['&:not(.btnContextual):focus']
    } : {
      ...btn.btnSmWrapper['&:focus .btnSm']
    },
    minWidth: '2.75rem',
    maxWidth: '16.25rem'
  };
  if (size === 'sm') {
    return (
      // eslint-disable-next-line react/button-has-type -- inherited
      jsx("button", _extends({
        css: btnWrapper
      }, otherProps, {
        ref: ref
      }), jsx("span", {
        css: cssStyle
      }, children))
    );
  }
  return (
    // eslint-disable-next-line react/button-has-type -- inherited
    jsx("button", _extends({
      css: cssStyle
    }, otherProps, {
      ref: ref
    }), children)
  );
});
ButtonBase.displayName = 'ButtonBase';
ButtonBase.defaultProps = {
  children: '',
  size: 'md',
  type: 'button',
  allowOverflow: false,
  theme: {},
  isDark: false
};
var ButtonBase$1 = ButtonBase;

export { ButtonBase$1 as default };
